<template>
	<!-- 设置团长活动机制 -->
	<el-drawer title="设置团长活动机制" size="50%" class="edit-shop" :visible.sync="dialogEditShopVisible" @close="resetForms('EditShopFrom')">
		<el-form :model="EditShopFrom" ref="EditShopFrom" label-width="150px" class="mt-24" :rules="EditShopRules">
			<el-row>
				<el-col :span="14">
					<el-form-item label="活动佣金率" prop="product_activity_ratio">
						<span>{{ row.commission_rate || '-' }} %</span>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14">
					<el-form-item prop="service_ratio">
						<span slot="label">
							<el-tooltip placement="top">
								<div slot="content">服务费率不得低于当前活动要求，<br />高于你的服务费率</div>
								<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
							</el-tooltip>
							活动服务费率
						</span>
						<el-input
							oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="EditShopFrom['service_ratio']"
							autocomplete="off"
							placeholder="请输入1以上的数字"
							suffix-icon="suffix-icon"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14">
					<el-form-item prop="promotion_end_time">
						<span slot="label">
							<el-tooltip placement="top">
								<div slot="content"
									>提报后团长审核通过则推广开始，<br />超7天未审核自动拒绝申请。<br />设定推广结束时间需大于活动要求最短推广周期。</div
								>
								<i class="iconfont icon-a-help-circle-obangzhu-xian"></i>
							</el-tooltip>
							推广结束时间
						</span>
						<el-date-picker v-model="value1" type="date" value-format="yyyy-MM-dd" @change="changeTimed" placeholder="选择日期"> </el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="14">
					<el-form-item prop="phone_number">
						<span slot="label"> 联系电话 </span>
						<el-input
							oninput="value=value.replace(/[^0-9.]/g,'')"
							v-model="EditShopFrom['phone_number']"
							autocomplete="off"
							placeholder="请输入联系电话"
						></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="footer mt-20 fz-14">
			<div>
				<el-checkbox v-model="checked">勾选代表同意</el-checkbox>
				<a href="https://automan.jinritemai.com/docpage/views/f853dd52-c2e8-4ed4-a4a6-9ef4700210fd" target="_blank" class="yx-color-primary ml-6"
					>《招商活动服务协议》</a
				>
			</div>
			<div class="flex">
				<el-button @click="dialogEditShopVisible = false">取 消</el-button>
				<el-button type="primary" @click="signUp">报 名</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import { validateTel } from '@/utils/validate';
import { applyactivity } from '@/api/secondColonelManage';
export default {
	name: 'editShopDialog',
	data() {
		return {
			dialogEditShopVisible: false,
			EditShopFrom: {
				service_ratio: '',
				promotion_end_time: '',
				phone_number: '',
			},
			EditShopRules: {
				service_ratio: [{ required: true, message: '请输入招商服务费率', trigger: 'blur' }],
				promotion_end_time: [{ required: true, message: '请选择推广结束时间', trigger: 'blur' }],
				phone_number: [{ required: true, validator: validateTel, trigger: 'blur' }],
			},
			row: {},
			activity_id: '',
			value1: '',
			checked: false,
			authorityId: '',
		};
	},
	methods: {
		//编辑商品机制
		async show(row, activity_id, authority_id) {
			this.activity_id = activity_id;
			this.authorityId = authority_id;
			this.radio = 0;
			this.row = row;
			this.dialogEditShopVisible = true;
		},
		//报名
		signUp() {
			const { activity_id, EditShopFrom, row, authorityId: authority_id } = this;
			EditShopFrom.activity_id = activity_id;
			EditShopFrom.product_activity_ratio = row.commission_rate;
			EditShopFrom.apply_id = row.id;
			EditShopFrom.authority_id = authority_id;
			EditShopFrom.outer_product_id = row.third_product_id;
			this.$refs['EditShopFrom'].validate(async valid => {
				if (valid) {
					if (!this.checked) {
						this.$message.warning('请先勾选《招商活动服务协议》');
						return;
					}
					const { code } = await applyactivity(EditShopFrom);
					if (code == 0) {
						this.$message.success('报名成功');
						this.dialogEditShopVisible = false;
					}
					this.$emit('refresh');
				}
			});
		},
		changeTimed(value) {
			this.EditShopFrom.promotion_end_time = value ? Date.parse(value) / 1000 - 8 * 3600 : '';
		},
		//重置弹框表单
		resetForms(from) {
			this.value1 = '';
			this.$refs[from].resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.edit-shop {
	/deep/ .suffix-icon::after {
		content: '%';
		width: 33px;
		background-color: #f7f8fa;
		border-bottom-right-radius: 2px;
		border-top-right-radius: 2px;
	}
	/deep/ .suffix-icon-1::after {
		content: '￥';
		width: 33px;
		background-color: #f7f8fa;
		border-bottom-right-radius: 2px;
		border-top-right-radius: 2px;
	}
	/deep/ .el-input__suffix {
		height: 92%;
		right: 1px;
		top: -1px;
	}
}
::v-deep .el-drawer__header {
	padding: 16px 24px !important;
	margin: 0;
	border-bottom: 1px solid #f5f5f5;
	span {
		color: #333;
		font-weight: bold;
	}
}
::v-deep .el-drawer__body {
	padding: 0px 24px !important;
}
::v-deep .el-date-editor {
	width: 100%;
}
.footer {
	width: 100%;
	position: absolute;
	bottom: 0;
	right: 0;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 20px;
	border-top: 1px solid #eeeeee;
}
</style>
